import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { SubscriptionPage } from '@/features/admin/subscription/subscription-page';
import { asPeriod, DEFAULT_PERIOD, type UsagePeriod } from '@/features/admin/usage/usage-model';
import { ConsoleShell } from '@/features/shell/console-shell';

/**
 * Entrée « Abonnement » (ADR 0089, chantier 5) : administrateur de la plateforme d'une installation `self-hosted`.
 * La période vit dans l'URL (`?period=30`) ; celle par défaut, 365 jours comme le backend, ne s'écrit pas.
 */
export const Route = createFileRoute('/$tenant/subscription')({
  validateSearch: (search: Record<string, unknown>): { period?: UsagePeriod } => {
    const period = asPeriod(search['period']);
    return period === DEFAULT_PERIOD ? {} : { period };
  },
  component: SubscriptionRoute,
});

function SubscriptionRoute() {
  const { tenant } = Route.useParams();
  const { period = DEFAULT_PERIOD } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="subscription"
      crumbs={[{ label: t('nav.items.subscription') }]}
    >
      <SubscriptionPage
        tenantId={tenant}
        period={period}
        onPeriodChange={(next) =>
          void navigate({ search: next === DEFAULT_PERIOD ? {} : { period: next }, replace: true })
        }
      />
    </ConsoleShell>
  );
}
